import { PATH_BASE } from '@/router/path';
import { ROUTES } from '@/router/routers';
import queryString from 'query-string';
import _ from 'lodash';
import dayjs from 'dayjs';

// 合并路径
export function combinePath(pathArray) {
    return pathArray.join('/');
}

// 获取绝对路径
export function getPath(pathArray, query, removeBasePath = false) {
    // 格式化query
    const queryStr = query ? queryString.stringify(query) : null;
    // removeBasePath 去除公共前缀，常用于login页面
    // 然后将传递进来的数组转为字符串
    return `${removeBasePath ? '' : PATH_BASE}/${pathArray.join('/')}${queryStr ? `?${queryStr}` : ''}`;
}

// 获取面包屑路径文字映射
export const getBreadcrumbNameMap = (map = {}, data = ROUTES) => {
    if (data) {
        data.forEach(({ path, breadcrumb, children }) => {
            if (path && breadcrumb) {
                // 解决多层级路由获取不正确
                map[path.substring(path.lastIndexOf('/') + 1)] = breadcrumb;
            }
            if (children) {
                getBreadcrumbNameMap(map, children);
            }
        });
    }
    return map;
};

// 获取列表的异步请求载荷
export const getListPayload = ({ form, formValue, pageNum, pageSize = 10 }) => {
    let val = {};
    if (formValue) {
        val = formValue;
    } else if (form) {
        val = form.getFieldsValue();
        val.earlytime = val.earlytime ? dayjs(val.earlytime).format('YYYY-MM-DD') : undefined;
        val.start_time = val.start_time ? dayjs(val.start_time).format('YYYY-MM-DD HH:mm:ss') : undefined;
        val.end_time = val.end_time ? dayjs(val.end_time).format('YYYY-MM-DD HH:mm:ss') : undefined;
        console.log(val, 'val');
    }
    return { ...val, page: pageNum, per_page: pageSize };
};

// 获取当前值在键值对中的文本
export const getLabelFromMap = ({ map, value }) => {
    if (!map) return '-';
    const current = map.find((item) => item.value === value);
    if (current) return current.label;
    return '-';
};

// 将一维数组转换成下拉框选项格式
export const createJsonOptions = (array) => {
    if (!_.isArray(array)) return [];
    return array.map((item, index) => ({ label: item, value: item, key: index }));
};

export function randomId() {
    let id = '';
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    for (let i = 0; i < 4; i++) {
        id += characters.charAt(Math.floor(Math.random() * 26));
    }
    const timestamp = new Date().getTime().toString().slice(-4);
    return `${id}${timestamp}`;
}
